module.exports = __webpack_public_path__ + "static/media/pytorch.8df89aab.svg";